module.exports = __webpack_public_path__ + "img/client_as.5ef9e8e3.svg";